import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { TrackerState } from "../../types/rtk/tracker/tracker";
import { trackerEndpoint } from "./tracker";

const initialState: TrackerState = {
  user_id: 0,
  country: "",
  language: "",
  tracker_id: 0,
  active_subscription: false,
};

function updateState(state: TrackerState, payload: TrackerState) {
  state.user_id = payload.user_id;
  state.country = payload.country;
  state.language = payload.language;
  state.tracker_id = payload.tracker_id;
  state.active_subscription = payload.active_subscription;
}

const TrackerSlice = createSlice({
  name: "tracker",
  initialState: initialState,
  reducers: {
    setTracker: (state, action: PayloadAction<TrackerState>) => {
      updateState(state, action.payload);
    },
  },
  extraReducers: (builder) => {
    builder.addMatcher(
      trackerEndpoint.endpoints.getTrackerState.matchFulfilled,
      (state, action) => {
        updateState(state, action.payload);
      }
    );
  },
});

export const { setTracker } = TrackerSlice.actions;
const TrackerReducer = TrackerSlice.reducer;
export default TrackerReducer;
